import * as React from 'react';
import Gallery, { importAll } from '../Gallery';

export const Florals = () => {
    const thumbImagesArray = React.useMemo(() => importAll(require.context('../../imgs/florals/thumbnails', false, /\.(png|jpe?g|svg)$/i)), []);
    const imagesArray = React.useMemo(() => importAll(require.context('../../imgs/florals', false, /\.(png|jpe?g|svg)$/i)), []);

    return <>
        {/* <h1>Florals</h1> */}
        <div className='services'>
            <div className="column-about">
                <div className='gar2'>Florals</div>
                <div className="fifty-pct">
                    We offer florals for intimate events of guest counts under 75, and florals are
                    priced based on a client’s specific needs.
                </div>
                <br></br>
                <div className="fifty-pct">
                    Exact pricing is provided after we
                    go over the details and floral design of your event.                
                </div>
                <br></br>
                <div className='service-breakdown'>bouquets</div>
                <div className='service-breakdown'>boutonnieres</div>
                <div className='service-breakdown'>corsages</div>
                <div className='service-breakdown'>ceremony decor</div>
                <div className='service-breakdown'>reception centerpieces</div>
                <br></br>
            </div>
        </div>
        <Gallery thumbImagesArray={thumbImagesArray} imagesArray={imagesArray} />
    </>;
};
